( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'alternating-icon-grid', COMPONENT );
} )( app );
